var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TableMultiLevel组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Table from '../Table';
import TableBody from '../TableBody';
import TableRow from '../TableRow';
import TableCell from '../TableCell';

import './TableMultiLevel.less';

var TableMultiLevel = function (_Component) {
    _inherits(TableMultiLevel, _Component);

    function TableMultiLevel(props) {
        _classCallCheck(this, TableMultiLevel);

        var _this = _possibleConstructorReturn(this, (TableMultiLevel.__proto__ || Object.getPrototypeOf(TableMultiLevel)).call(this, props));

        _this.arrowClickHandler = function (_ref) {
            var position = _ref.position;

            var showMultiLevelCopy = _.cloneDeep(_this.state.showMultiLevel);
            var obj = _this.iteratorfindObj(showMultiLevelCopy, position);
            obj.isShowChildren = !obj.isShowChildren;
            _this.setState({ showMultiLevel: showMultiLevelCopy });
        };

        _this.iteratorTableRowCount = 0;
        _this.state = {
            showMultiLevel: _this.iteratorFormatData(props.data)
        };
        return _this;
    }

    _createClass(TableMultiLevel, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.data, this.props.data)) {
                this.setState({
                    showMultiLevel: this.iteratorFormatData(np.data)
                });
            }
        }
    }, {
        key: 'iteratorFormatData',
        value: function iteratorFormatData(data) {
            var _this2 = this;

            if (!data) {
                return;
            }
            return data.map(function (item) {
                return {
                    isShowChildren: item.isShowChildren ? item.isShowChildren : false,
                    children: _this2.iteratorFormatData(item.children)
                };
            });
        }
    }, {
        key: 'iteratorfindObj',
        value: function iteratorfindObj(arr, position) {
            if (!position || position.length === 0) {
                return arr;
            }

            var _position = _toArray(position),
                index = _position[0],
                other = _position.slice(1);

            if (position.length === 1) {
                return arr[index];
            }
            return this.iteratorfindObj(arr[index].children, other);
        }

        // dataArr,迭代数据；num，第几层迭代；position，记录当前迭代层次坐标。

    }, {
        key: 'iteratorTableRow',
        value: function iteratorTableRow(dataArr, num) {
            var _this3 = this;

            var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var _props = this.props,
                uniqueKeyName = _props.uniqueKeyName,
                columnConfigs = _props.columnConfigs;

            if (!dataArr) {
                return;
            }
            return dataArr.map(function (parentRowData, rowIndex) {
                var hasChildren = _.hasIn(parentRowData, 'children');
                var isShowChildren = _this3.iteratorfindObj(_this3.state.showMultiLevel, [].concat(_toConsumableArray(position), [rowIndex])).isShowChildren;
                return [React.createElement(
                    TableRow,
                    { key: parentRowData[uniqueKeyName] },
                    columnConfigs.map(function (colData, index) {
                        var refer = colData.refer,
                            render = colData.render;

                        var tableCellStyle = {};
                        return React.createElement(
                            TableCell,
                            { key: colData.refer + index, style: tableCellStyle },
                            index === 0 && React.createElement('span', {
                                className: classnames({
                                    'first-td-padding-left': true
                                }),
                                style: {
                                    width: hasChildren ? num * 20 : num * 20 + 26
                                }
                            }),
                            hasChildren && index === 0 && React.createElement('span', {
                                className: classnames({
                                    'children-arrow': true,
                                    active: isShowChildren
                                }),
                                onClick: function onClick() {
                                    return _this3.arrowClickHandler({
                                        position: [].concat(_toConsumableArray(position), [rowIndex])
                                    });
                                }
                            }),
                            _.isFunction(render) ? render(parentRowData[refer], rowIndex, parentRowData, _this3.props.data) : parentRowData[refer]
                        );
                    })
                ), isShowChildren && _this3.iteratorTableRow(parentRowData.children, num + 1, [].concat(_toConsumableArray(position), [rowIndex]))];
            });
        }
    }, {
        key: 'tabelMultiLevelBody',
        value: function tabelMultiLevelBody() {
            return React.createElement(
                TableBody,
                null,
                this.iteratorTableRow(this.props.data, 0)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            return React.createElement(
                Table,
                _extends({}, this.props, {
                    className: classnames((_classnames = {}, _defineProperty(_classnames, this.props.className, this.props.className), _defineProperty(_classnames, 'table-multi-level', true), _classnames))
                }),
                this.tabelMultiLevelBody()
            );
        }
    }]);

    return TableMultiLevel;
}(Component);

TableMultiLevel.propTypes = {
    data: PropTypes.array,
    columnConfigs: PropTypes.array,
    uniqueKeyName: PropTypes.string,
    className: PropTypes.string
};
TableMultiLevel.defaultProps = {
    data: [],
    columnConfigs: [],
    uniqueKeyName: 'id'
};
export default TableMultiLevel;